/* eslint-disable object-curly-newline,no-param-reassign */
import update from 'immutability-helper';

export const API_LOAD_EMPLOYEE_STATS = 'API_LOAD_EMPLOYEE_STATS';
const API_LOAD_EMPLOYEE_STATS_FAILED = 'API_LOAD_EMPLOYEE_STATS_FAILED';
const API_LOAD_EMPLOYEE_STATS_LOADING = 'API_LOAD_EMPLOYEE_STATS_LOADING';
const API_LOAD_EMPLOYEE_STATS_LOADED = 'API_LOAD_EMPLOYEE_STATS_LOADED';

const defaultState = { employeeStats: [], loading: false };

const group = response => response.reduce(
  (map, obj) => {
    if (!map[obj.employee.name]) map[obj.employee.name] = {};
    if (!map[obj.employee.name][obj.project.name]) map[obj.employee.name][obj.project.name] = {};

    const date = new Date(obj.workorder.wo_date);
    const dateKey = `${date.getUTCMonth() + 1}/${date.getUTCDate()}`;

    if (map[obj.employee.name][obj.project.name][dateKey] === undefined) {
      obj["hours"] = parseFloat(obj["hours"]);
      map[obj.employee.name][obj.project.name][dateKey] = obj;
      map[obj.employee.name][obj.project.name][dateKey]['workorders'] = [obj.workorder_id]
    } else {
      let hours = map[obj.employee.name][obj.project.name][dateKey]['hours'];
      map[obj.employee.name][obj.project.name][dateKey]['hours'] = hours + parseFloat(obj['hours']);
      map[obj.employee.name][obj.project.name][dateKey]['workorders'].push(obj.workorder_id)
    }

    return map;
  },
  {},
);

export const reducer = (state = defaultState, { type, response }) => {
  switch (type) {
    case API_LOAD_EMPLOYEE_STATS_LOADED:
      return update(state, {
        loading: { $set: false },
        employeeStats: { $set: group(response) },
      });
    case API_LOAD_EMPLOYEE_STATS_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_EMPLOYEE_STATS_FAILED:
      return update(state, { loading: { $set: false } });
    default:
      return state;
  }
};

export const loading = state => state.employeeStats.loading;
export const stats = state => state.employeeStats.employeeStats;


export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/employeeStats/employeeStats.reducer.js